import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { UK_TIMEZONE } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.helpers';
import { DatesWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { DatePickerComponent } from 'src/main/cms/DatePicker/DatePickerComponent';
import { HomePageCarouselDateState } from 'src/main/cms/HomePageCarousel/HomePageCarouselForm/HomePageCarouselDateState';

export const Dates = observer(
    ({
        carouselPromoState,
        changeConfirmable = false,
    }: {
        carouselPromoState: HomePageCarouselState;
        changeConfirmable?: boolean;
    }) => {
        const [state] = useState(() => new HomePageCarouselDateState(carouselPromoState, UK_TIMEZONE));
        const {
            onChangeStartDate,
            onBlurStartDate,
            onChangeEndDate,
            onBlurEndDate,
            startDateWithOffset,
            endDateWithOffset,
        } = state;
        const { optInOnly, dateFrom, dateTo, handleChangeWithConfirmation } = carouselPromoState;
        return (
            <DatesWrapper>
                <DatePickerComponent
                    id='Start-date'
                    label='Start date'
                    isEmpty={startDateWithOffset === null}
                    disabled={optInOnly !== false}
                    selected={startDateWithOffset}
                    onChange={
                        changeConfirmable ? handleChangeWithConfirmation('start', onChangeStartDate) : onChangeStartDate
                    }
                    onBlur={onBlurStartDate}
                    dateState={dateFrom}
                />
                <DatePickerComponent
                    id='End-date'
                    label='End date'
                    isEmpty={endDateWithOffset === null}
                    selected={endDateWithOffset}
                    onChange={
                        changeConfirmable ? handleChangeWithConfirmation('end', onChangeEndDate) : onChangeEndDate
                    }
                    onBlur={onBlurEndDate}
                    dateState={dateTo}
                />
            </DatesWrapper>
        );
    }
);
